import {DiscordUser} from "../types/simc";
import {API_BASE} from "./api";
import axios from "axios";

class UserService {
    private static instance: UserService;

    public static getInstance(): UserService {
        if (!UserService.instance) {
            UserService.instance = new UserService();
        }
        return UserService.instance;
    }

    async getUser(discordId: string): Promise<DiscordUser> {
        const response = await axios.get(`${API_BASE}/users/${discordId}`);
        return response.data;
    }
}

export default UserService.getInstance();

